<template>
  <IonPage>
  <master-layout pageTitle="مشاهده جزئیات درآمد">
    <ion-card v-if="commission_details">
      <ion-card-content>
        <div class="space-between">
          <div>شماره سند</div>
          <div>{{commission_details.doc_number}}</div>
        </div>
        <div class="space-between">
          <div>از تاریخ</div>
          <div>{{commission_details.s_date}}</div>
        </div>
        <div class="space-between">
          <div>تا تاریخ</div>
          <div>{{commission_details.e_date}}</div>
        </div>
        <div class="space-between">
          <div>جمع کمیسیون شما</div>
          <div>{{commission_details.total_commission_amount}}</div>
        </div>
      </ion-card-content>
    </ion-card>
    <ion-card v-if="commission_item">
      <ion-card-content>
        <div class="table-responsive">
          <table class="table">
            <thead>
            <th>نوع پورسانت</th>
            <th>درصد پورسانت</th>
            <th>مقدار پورسانت</th>
            <th>مقدار فروش</th>
            </thead>
            <tbody>
            <tr v-for="(item, index) in commission_item" :key="index">
              <td>
                <div v-if="item.type === 'total' ">پورسانت کل فروش</div>
                <div v-if="item.type === 'product' ">محصول ({{item.select_info.title}})</div>
                <div v-if="item.type === 'customer' ">مشتری ({{item.select_info.title}})</div>
                <div v-if="item.type === 'price' ">قیمت (از {{item.start_price}} تا {{item.end_price}})</div>
                <div v-if="item.type === 'category' ">دسته بندی ({{item.select_info.title}})</div>
              </td>
              <td>{{item.commission_percent}} %</td>
              <td>{{item.commission_amount}}</td>
              <td>{{item.total_sell_amount}}</td>
            </tr>
            </tbody>
          </table>
        </div>

      </ion-card-content>
    </ion-card>
  </master-layout>
  </IonPage>
</template>

<script>

import {mapActions} from "vuex";
import {IonPage} from "@ionic/vue";
export default {
  name: "view",
  components: {IonPage},
  data()
  {
    return {
      id: null,
      commission_details: null,
      commission_item: [],
    }
  },
  async created()
  {
    await this.init();
  },
  methods: {
    async init(){
      this.id = this.$route.params.id;
      const result =await this.getCommission(this.id);
      if(result.ok)
      {
        this.commission_details = result.visitorCommission;
        this.commission_item = result.items;
      }
    },
    ...mapActions('commission',{
      getCommission: 'getCommission',
    })
  }
}
</script>

<style scoped>
.space-between
{
  display: flex;
  justify-content: space-between;
}

</style>